<template lang="pug">
  div.municipalities
    div.table-choose-panel
      div.toolbar-table
        e-select-list(
        :options="selectListOptions"
        v-model="operationType"
        )

        div.toolbar.toolbar--modal
          div.line
            div.search
              form(@submit.prevent.stop="startSearch()").search
                input(
                type="search"
                v-model="searchQ"
                placeholder=""
                )
            div.actions-panel
              e-button-edit(
              @click.stop.prevent="addNewRowToTable"
              )

      div
        e-table-inner(
        :visibleColumns="visibleColumns"
        :itemsEndpoint="endpointListForInnerTable"
        @deleteItem="deleteItem"
        ref="innerTable"
        )

      e-modal(v-if="showModal"
      @close="showModal = false"
      @confirm="saveList()"
      title="Выбор муниципальных образований"
      )
        slot
          e-table-checked-list(
          @checkedChange="listUpdate"
          :endpoint="endpointList"
          :earlyCheckedItems="earlyChecked"
          :showPaginate="true"
          defaultColWidth="100%"
          )

        template(slot="footer") Выбор муниципальных образований
          div.search-result
            span Выбрано {{checkedLen}} объектов
          div
            button(
            type="button"
            @click="closeModal()"
            ).actions-filter-panel__button.standart.standart-noborder Отмена
            button(
            type="button"
            @click="saveList()"
            ).actions-filter-panel__button.standart Сохранить


</template>

<script>
  import {atu} from '../../../api/api-endpoints.js'

  export default {
    name: 'municipalities',
    props: {
      fields: Object,
      apo: false,
    },
    data () {
      return {
        searchQ: '',
        operationType: null,
        showModal: false,
        checkedLen: 0,
        checked: []
      }
    },
    computed: {
      visibleColumns () {
        return {
          name: {label: 'Наименование'},
          parent_name: {label: 'Муниципальное образование'},
          total_residents: {label: 'Численность населения, в тыс. чел.'}
        }
      },
      selectListOptions () {
        return [
          {
            id: 'municipalities',
            name: 'Подконтрольные муниципальные образования'
          }
        ]
      },
      earlyChecked () {
        return {default: this.fields.mos}
      },
    },
    methods: {
      startSearch () {
        this.$refs.innerTable.updateTable()
      },
      updateDataInInnerTable () {
        this.$refs.innerTable.updateTable()
      },
      deleteItem (item) {
        let tmp = []
        this.fields.mos.forEach(vId => {
          if (item.id !== vId) {
            tmp.push(vId)
          }
        })
        let fields = Object.assign(this.fields, {mos: tmp})
        this.$set(this.fields, fields)
        this.$emit('delete')
        this.updateDataInInnerTable()
      },
      endpointListForInnerTable (ctx, query = {'per-page': 10}) {
        let route = {query}
        if (ctx.q) {
          route.query.q = ctx.q
        }
        if (ctx.paginateObj) {
          route.query = Object.assign(route.query, ctx.paginateObj)
        }
        if (ctx.currentSort) {
          route.query.sort = ctx.currentSort
        }
        if (this.fields && this.fields.mos && this.fields.mos.length) {
          route.query.id = this.fields.mos.join(',')
        } else {
          route.query.id = [-1]
        }

        if (this.searchQ) {
          route.query.q = this.searchQ
        } else {
          delete route.query.q
        }
        return {
          url: atu.atuObjects(route),
          fields: {
            name: {
              label: 'Муниципальное образование'
            }
          }
        }
      },
      endpointList (ctx, query = {'per-page': 50}) {
        let route = {query}
        if (ctx.q) {
          route.query.q = ctx.q
        }
        if (ctx.paginateObj) {
          route.query = Object.assign(route.query, ctx.paginateObj)
        }
        if (ctx.currentSort) {
          route.query.sort = ctx.currentSorttemplate(slot="footer")
        }

        route.query.null_apo = this.apo

        return {
          url: atu.apoObjects(route),
          fields: {
            name: {
              label: 'Наименование',
            },
            parent_name: {
              label: 'Муниципальное образование'
            }
          }
        }
      },
      listUpdate ($event) {
        let {checked, checkedLen} = $event
        this.checkedLen = checkedLen
        this.checked = checked
      },
      saveList () {
        console.log('saveList', this.checked)
        let fields = Object.assign(this.fields, {mos: JSON.parse(JSON.stringify(this.checked.default))})
        this.$set(this.fields, fields)
        this.closeModal()
        this.$emit('saved')
      },
      closeModal () {
        this.showModal = false
        this.checkedLen = 0
      },
      openModal () {
        this.showModal = true
      },
      addNewRowToTable () {
        this.openModal()
      }
    }
  }
</script>
